import { Box, Skeleton, TableCell, TableRow } from "@mui/material";

const ListThubnail = () => (
  <TableCell
    sx={{
      maxWidth: "9.25rem",
      borderColor: "#1f3046",
      pl: 0
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <Skeleton height={24} width={24} variant='rounded' sx={{ background: "#3a4350" }} />
      <Box sx={{ flex: 1, width: "100%" }}>
        <Skeleton height={10} width={"90%"} sx={{ background: "#3a4350" }} />
        <Skeleton height={10} width={"50%"} sx={{ background: "#3a4350" }} />
      </Box>
    </Box>
  </TableCell>
);

export default function ListViewSkeleton({ column = 3, cellOnly }: { column?: number; cellOnly?: boolean }) {
  const renderRestColumns = Array.from({ length: column }).map((_, idx) => {
    return (
      <TableCell
        key={`list-skeleton-${idx}`}
        sx={{
          maxWidth: "4.5625rem",
          width: "4.5625rem",
          borderColor: "#1f3046"
        }}
      >
        <Skeleton height={10} width={"90%"} sx={{ background: "#3a4350" }} />
      </TableCell>
    );
  });

  // Return skeletons without row
  if (cellOnly)
    return (
      <>
        <ListThubnail />
        {renderRestColumns}
      </>
    );

  return (
    <TableRow
      hover
      sx={{
        background: "#222d3c"
      }}
      className='list-skeleton'
    >
      <ListThubnail />
      {renderRestColumns}
    </TableRow>
  );
}
